export default "__VITE_ASSET__dhaGC1SG__"